import styled from 'styled-components'
import React from 'react'
export const ProfessionalStatus = ({ color, icon }) => {
  return <ProfessionalStatusWrapper color={color}>{icon && <i className={icon} />}</ProfessionalStatusWrapper>
}
export const ProfessionalStatusWrapper = styled.div`
  width: 20px;
  height: 20px;
  background: ${({ color }) => color};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  i {
    font-size: 10px;
  }
`
